/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/hamburger': {
    width: 31,
    height: 25,
    viewBox: '0 0 31 25',
    data: '<path pid="0" _fill="#E25046" d="M0 0h31v5.001H0zM0 10.009h31v5.001H0zM0 19.999h31V25H0z"/>'
  }
})
